import formats from '../../api/formats'
import server from '../../api/server'
import store from '../../store'

import AssistClasses from '../assist/AssistClasses.js'

class Strategy extends AssistClasses.Strategy {
  getTypeCode () {
    return 'Action'
  }
  getTypeName () {
    return 'Операция'
  }
  setContext (cxt) {
    this.context = cxt
  }
  createModel () {
    var model = new Model()
    return model
  }
  createModelFromJSON (json) {
    return Object.assign(this.createModel(), JSON.parse(json))
  }
  createDefaultModel () {
    return Object.assign(this.createModel(), {})
  }
  createModelFromData (data) {
    return Object.assign(this.createModel(), data)
  }
  updateSteps (scheme) {
    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-flex',
            name: 'actionCode',
            grow: true,
            size: {sm6: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewTitle (model) {
    var it = this.formatActionData(model)
    return it.caption ? it.caption : this.getTypeName()
  }
  viewTitleComp (model) {
    return formats.createComp(`<span>${this.viewTitle(model)}</span>`)
  }
  viewContentComp (model) {
    if (!model) {
      return ''
    }
    const _f = (v) => v || '-'
    const _b = (v) => v || ''
    const _s = (rCode, model) => {
      let finished = (model['finished'] && formats.formatDateTime(model['finished']) || null)
      const statuses = {
        'OK': `Выполнено: ${_f(finished)}`,
        'ERROR': `Отменено: ${_f(finished)}`,
        'CANCEL': `Отменено: ${_f(finished)}`,
        'PROCESS': `Выполняется: ${_f(finished)}`,
        'SCHEDULE': `Ожидает выполнения`
      }
      return statuses[rCode]
    }
    let rCode = model['started'] && model['resultCode'] || model['scheduled'] && 'SCHEDULE' || model['started'] && 'PROCESS'
    let it = this.formatActionData(model)
    let details = this.formatActionDetails(model)
    let oper = `<div>Оператор: <b>${_f(model['accountNameShort'])}</b></div>`
    return formats.createComp(`
      <div>
        <div>Тип операции: <b>${_f(it && it.caption)}</b></div>
        ${oper || ''}
        <div>Запланировано: <b>${_f(model['scheduled'] ? formats.formatDateTime(model['scheduled']) : null)}</b></div>
        <div>Начато: <b>${_f(model['started'] ? formats.formatDateTime(model['started']) : null)}</b></div>
        <div><b>${_s(rCode, model)}</b></div>
        ${it && it.state ? `<div>${it.state}</div>` : ``}
        <div>${_f(it && it.data)}</div>
        <div>${_b(details && details.data)}</div>
      </div>
    `)
  }
  viewContentListComp (model) {
    if (!model) {
      return ''
    }
    var it = this.formatActionData(model)
    return formats.createComp(`
      <span>
        ${!it.data ? '' : it.data}${!it.state ? '' : ' Статус: ' + it.state}
      </span>
    `)
  }
  viewContentList (model) {
    if (!model) {
      return ''
    }
    var it = this.formatActionData(model)
    return `
      <span>
        ${it.caption}${!it.data ? '' : ': ' + it.data}${!it.state ? '' : ' Статус: ' + it.state}
      </span>
    `
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
  }

  getDepoLinkUrl (depoId, title) {
    if (!depoId) {
      return ''
    }
    return `<a href="${store.getters.getDepoUrl(depoId)}" target="blank">${title}</a>`
  }

  formatActionData (item) {
    const getPostType = (typeCode) => store.getters.getPostTypes && store.getters.getPostTypes.has(typeCode) ? store.getters.getPostTypes.get(typeCode).caption : typeCode
    const _f = (v) => v || '-'
    try {
      var result
      if (!item) {
        return result
      }
      var caption
      var jsn = JSON.parse(item.data)
      console.log('formatActionData', jsn, item)
      switch (item.actionCode) {
        case 'LOGIN':
          return {caption: `Начат сеанс работы`, data: `адрес ${jsn.ip}, браузер ${jsn.userAgent}`}
        case 'REFRESH':
          return {caption: `Продолжен сеанс работы`, data: `адрес ${jsn.ip}, браузер ${jsn.userAgent}`}
        case 'AGENT_CREATE':
          return {caption: `Создал пользователя `, data: `${jsn.username}`}
        case 'AGENT_UPDATE':
          return {caption: `Изменил пользователя `, data: `${jsn.username}`}
        case 'AGENT_DELETE':
          return {caption: `Удалил пользователя `, data: `${jsn.username}`}
        case 'AGENT_RESET_PASSWORD':
          return {caption: `Сбросил пароль пользователя `, data: `${jsn.username}`}
        case 'CLIENT_UPDATE':
          return {caption: `Изменил описание компании `, data: ``}
        case 'POST_ACTION_CREATE':
          return {caption: `Создал юридически значимое сообщение `, data: `${getPostType(jsn.typeCode)}`}
        case 'POST_ACTION_APPLY':
          return {caption: `Ответил на юридически значимое сообщение `, data: `${getPostType(jsn.typeCode)}`}
        case 'MONITORING_SWITCH':
          if (jsn.monitoring) {
            return {caption: `Включил мониторинг`, data: `адрес: ${JSON.stringify(jsn.email, null, ' ')}`}
          } else {
            return {caption: `Выключил мониторинг`, data: null}
          }
        case 'MONITORING_UPDATE':
          result = JSON.parse(item.result)
          return {caption: jsn.monitoring ? `Поставил на мониторинг` : `Убрал с мониторинга`, data: `Компании (${result.applyed.length}) [${result.applyed.length > 0 ? result.applyed.join(', ') : '-'}] ${result.errors.length > 0 ? ', ошибочные инн (' + result.errors.length + ')[' + result.errors.join(', ') + ']' : ''}.`}
        case 'FAVORITE_COMPANY_UPDATE':
          result = JSON.parse(item.result)
          caption = jsn.operation === 'UPDATE' ? `Добавление/изменение котрагентов` : `Неизвестная операция`
          caption = jsn.operation === 'DELETE' ? `Удаление котрагентов` : caption
          return {caption: caption, data: `Компании (${result.applyed.length}) [${result.applyed.length > 0 ? result.applyed.join(', ') : '-'}] ${result.errors.length > 0 ? ', ошибочные инн (' + result.errors.length + ')[' + result.errors.join(', ') + ']' : ''}.`}
        case 'CLIENT_INDIVIDUAL_UPDATE':
          result = JSON.parse(item.result)
          caption = jsn.operation === 'UPDATE' ? `Добавление/изменение записей о Физ. лице` : `Неизвестная операция`
          caption = jsn.operation === 'DELETE' ? `Удаление записей о Физ. лице` : caption
          let errors = Object.entries(result.errors).map(([k, v]) => `${k} - ${v}`)
          return {caption: caption, data: `(${result.applyed.length}) [${result.applyed.length > 0 ? result.applyed.join(', ') : '-'}] ${errors.length > 0 ? ', ошибочные данные (' + errors.length + ') [' + errors.join(', ') + ']' : ''}.`}
        case 'SIGN_FILE':
          result = JSON.parse(item.result)
          return {caption: `Заверил копии `, data: `Документы (${result.applyed.length}) [${result.applyed.length > 0 ? result.applyed.join(', ') : '-'}] ${result.errors.length > 0 ? ', ошибочные идентификаторы (' + result.errors.length + ')[' + result.errors.join(', ') + ']' : ''}.`}
        case 'DEPO_MATTER':
          result = item.result ? JSON.parse(item.result) : null
          if (result && result.message) {
            return {caption: `Подготовка и депонирование документов `, data: result && result.depoId ? `Документ: ${result.depoId}` : result.message ? result.message : 'Документ: -'}
          } else {
            return {caption: `Подготовка и депонирование документов`, data: `Документ: ${result && result.depoId ? result.depoId : '-'}${result && result.errors ? ' Ошибка: ' + result.errors : ''}`}
          }
        case 'DEPO_PACKAGE':
          result = item.result ? JSON.parse(item.result) : null
          if (result && !result.errors) {
            return {caption: `Подготовка и депонирование документов `, data: `Шаблон: ${_f(jsn.deedId)}`}
          } else {
            return {caption: `Подготовка и депонирование документов `, data: `Шаблон: ${_f(jsn.deedId)} ${result && result.errors || ''}`}
          }
        case 'SEND_MAIL':
          result = item.result ? JSON.parse(item.result) : null
          if (result && !result.errors) {
            return {caption: `Отправление письма`, data: `<b>${_f(jsn.subject)}</b> для ${_f(jsn.email)} из ${_f(result.mailbox)}`}
          } else {
            return {caption: `Отправление письма`, data: `<b>${_f(jsn.subject)}</b> для ${_f(jsn.email)} из ${_f(jsn.mailbox)}  ${result && result.errors || ''}`}
          }
        case 'SEND_MATTER':
          result = item.result ? JSON.parse(item.result) : null
          if (result && result.message) {
            return {caption: `Подготовлена рассылка документов дела `, data: `<b>${_f(jsn.subject)}</b>`}
          } else {
            return {caption: `Подготовлена рассылка документов дела  `, data: `<b>${_f(jsn.subject)}</b> ${result && result.errors || ''}`}
          }
        case 'SEND_PACKAGE':
          result = item.result ? JSON.parse(item.result) : null
          if (result && !result.errors) {
            return {caption: `Подготовлено письмо с документами дела `, data: `<b>${_f(jsn.subject)}</b>`}
          } else {
            return {caption: `Подготовлено письмо с документами дела  `, data: `<b>${_f(jsn.subject)}</b> ${result && result.errors || ''}`}
          }
        case 'MATTER_RUN':
          result = item.result ? JSON.parse(item.result) : null
          let action = jsn.command.indexOf('send_mail') > 0 ? 'подготовка письма' : (jsn.command.indexOf('wait_mail') > 0 ? 'ожидание письма' : 'проверка поля')
          if (result && !result.errors) {
            return {caption: `Действие ${action} `, data: `<b>${_f(jsn.fieldLabel || jsn.command)}</b>`}
          } else {
            return {caption: `Действие ${action} `, data: `<b>${_f(jsn.fieldLabel || jsn.command)}</b> ${result && result.errors && '<br/>' + result.errors || ''}`}
          }
        default:
          return {caption: `Совершил неизвестную операцию`, data: `Данные: ${JSON.stringify(jsn, null, ' ')}`}
      }
    } catch (e) {
      return {caption: `Совершил неизвестную операцию`, data: `Данные: ${item.data}`}
    }
  }
  formatActionDetails (item) {
    const _f = (v) => v || '-'
    try {
      var result
      if (!item) {
        return result
      }
      var jsn = JSON.parse(item.data)
      switch (item.actionCode) {
        case 'DEPO_MATTER':
          result = item.result ? JSON.parse(item.result) : null
          return {data: result ? '<br/>' + this.getDepoLinkUrl(result.depoId, 'Ссылка на документ в депозитарии') : ''}
        case 'DEPO_PACKAGE':
          result = item.result ? JSON.parse(item.result) : null
          return {data: result ? '<br/>' + this.getDepoLinkUrl(result.depoId, 'Ссылка на документ в депозитарии') : ''}
        case 'SEND_PACKAGE':
          return {data: `<br/>${_f(jsn.body)}`}
        case 'SEND_MAIL':
          return {data: `<br/>${_f(jsn.body)}`}
        case 'MATTER_RUN':
          return {data: `<br/> ${_f(jsn.command)} <br/><br/>Название поля: ${_f(jsn.fieldName)}`}
        default:
          return null
      }
    } catch (e) {
      return {caption: `Совершил неизвестную операцию`, data: `Данные: ${item.data}`}
    }
  }
  getItems (actionId, cb) {
    const cbError = (e) => {
      this.isLoading = false
      this.context.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении данных операции '})
    }
    server.apiGet(
      '/api/me/actions/' + actionId,
      cb,
      cbError)
  }
  fetchData (itemId) {
    return new Promise((resolve, reject) => {
      const cb = item => resolve(item)
      if (itemId) {
        this.getItems(itemId, cb)
      } else {
        resolve(null)
      }
    })
  }
}

class Model {
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/profile/Action.js